import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	flex-direction: column;
  position: fixed;
  top: 60px;
  right: ${props => props.open ? '0px' : '-350px'};
  width: 350px;
  height: calc(100vh - 60px);
  background-color: white;
  transition: background-color 0.3s ease-out, right 0.2s ease-out;
	z-index: 1;
	opacity: ${props => props.saving ? '0.5' : '1'};
	pointer-events: ${props => props.saving ? 'none' : 'auto'};
`;

const Wrapper = styled.div`
	max-height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	flex-grow: 1;
`;

const Actions = styled.div`
	padding: 40px;
	border-top: 0px solid #F2F2F2;
	position: relative;

	&:before {
		content: "";
		position: absolute;
		bottom: 100%;
		left: 0px;
		width: 100%;
		height: 16px;
		z-index: 1;
		background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
	}

	button {
		width: 100%;
	}
`;

export {
	Container,
	Wrapper,
	Actions,
}
